import { LS_HAS_SELLER_SEEN_MODAL_KEY, LS_HAS_BUYER_SEEN_MODAL_KEY } from './constants';

export const hasBuyerSeenFavoritesModal = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  return !!window.localStorage.getItem(LS_HAS_BUYER_SEEN_MODAL_KEY);
};

export const hasSellerSeenFavoritesModal = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  return !!window.localStorage.getItem(LS_HAS_SELLER_SEEN_MODAL_KEY);
};
